import React from 'react'

function Header() {
    return (
        <div>
            <header className="header">Boodschappenlijst</header>
        </div>
    )
}

export default Header